import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { landingPageDesignsKeys } from './landingPageDesignsKeys';
import { LandingPageDesignAccess } from './useQueryLandingPageDesigns';

const getLandingPageDesignAccess = async (
  landingPageDesignId: number | null
): Promise<LandingPageDesignAccess[]> => {
  return (
    await EXPRESS_API.get(
      `/superadmin/landing-page-designs/${landingPageDesignId}/access`
    )
  ).data;
};

export const useQueryLandingPageDesignAccess = (
  templateId: number | null,
  enabled: boolean
) => {
  return useQuery(
    landingPageDesignsKeys.design_access(templateId),
    () => getLandingPageDesignAccess(templateId),
    {
      refetchOnMount: true,
      staleTime: 0,
      enabled,
      onError: () => {
        errorToast({
          title: `We're currently experiencing difficulties fetching design access.`,
        });
      },
    }
  );
};
